export default "__VITE_ASSET__rzetY1jJ__"